// ヘッダに関するアクションを制御するためのJS
// Theme.jsにあるものは記述しない
(() => {
    // SP版の判定（ここでは幅768px 以下をSP版とみなす）
    if (!window.matchMedia("(max-width: 640px)").matches) {
        return; // SP版以外（PCなど）は以降の処理を実行しない
    }

    const header = document.getElementsByClassName("shopify-section__header")[0];
    const announcement = document.querySelector(".announcement-bar"); // 実際のクラス／IDに合わせて変更してください
    const searchBarElement = document.querySelector(".search-bar"); // 検索バー要素を取得
    const THRESHOLD = 10; // 10px ずつ動いたら判定する閾値
    let lastToggleY = window.scrollY; // 最後にクラスを切り替えたときの scrollY
    let ticking = false;

    function isAnnouncementVisible() {
        if (!announcement) return false;
        const rect = announcement.getBoundingClientRect();
        return rect.bottom > 0;
    }

    function isSearchExpanded() {
        return searchBarElement && searchBarElement.classList.contains("is-expanded");
    }

    function onScroll() {
        const currentY = window.scrollY;

        if (isSearchExpanded() || isAnnouncementVisible()) {
            // 検索バー展開中／お知らせバーが表示中は常に header--scrolled を外す
            if (header.classList.contains("header--scrolled")) {
                header.classList.remove("header--scrolled");
            }
            lastToggleY = currentY;
            ticking = false;
            return;
        }

        const delta = currentY - lastToggleY;

        if (delta > THRESHOLD) {
            if (!header.classList.contains("header--scrolled")) {
                header.classList.add("header--scrolled");
            }
            lastToggleY = currentY;
        } else if (delta < -THRESHOLD) {
            if (header.classList.contains("header--scrolled")) {
                header.classList.remove("header--scrolled");
            }
            lastToggleY = currentY;
        }
        ticking = false;
    }

    function requestTick() {
        if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
        }
    }

    window.addEventListener("scroll", requestTick, { passive: true });
})();
